export default __webpack_public_path__ + "usa_map.a39209cd.glb";